import type { ApiMeta } from "@/apis/types";

/**
 * API metadata for WSDOT Highway Cameras API
 */
export const wsdotHighwayCamerasApiMeta: ApiMeta = {
  name: "wsdot-highway-cameras",
  baseUrl:
    "https://www.wsdot.wa.gov/traffic/api/highwaycameras/highwaycamerasrest.svc",
};
